export default "__VITE_ASSET__DnT16ZUz__"